import { render, staticRenderFns } from "./SolePropJ.vue?vue&type=template&id=4cb62066&scoped=true"
import script from "./SolePropJ.vue?vue&type=script&lang=js"
export * from "./SolePropJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb62066",
  null
  
)

export default component.exports